<template>
    <div class="docs col-md-8 ml-sm-auto col-lg-9 px-4">
      <h1>Документы</h1>
      <b-button-group class="head-group">
        <b-button variant="success" v-b-modal.modal-add-doc>Добавить</b-button>
      </b-button-group>
      <b-col lg="12" class="my-1">
        <b-form-group
          label="Фильтр"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Введите фразу/слово для поиска"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Очистить</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <div class="row">
        <b-table :filter="filter" striped :busy="isBusy" hover :fields="fields" :items="items" table-variant="dark" >
          <template v-slot:cell(id)="data">
            <b-button variant="success" @click="edit_item(data.value)" ref="btnEdit"><i class="fas fa-edit"></i></b-button>
            <b-button variant="secondary" @click="delete_item(data.value)"><i class="fas fa-trash-alt"></i></b-button>
          </template>
          <template v-slot:cell(link)="data">
            <a class="link_doc" :href="data.value">Ссылка на документ</a>
          </template>
        </b-table>
      </div>
      <modal-add @docs="init"></modal-add>
      <modal-edit @docs="init"></modal-edit>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import modalAdd from './ModalAdd';
import modalEdit from './ModalEdit';

export default {
  props: {
  },
  components: {
    'modal-add': modalAdd,
    'modal-edit': modalEdit,
  },
  data() {
    return {
      isBusy: false,
      filter: null,
      fields: [
        { key: 'name', label: 'Название', sortable: true },
        { key: 'link', label: 'Ссылка', sortable: true },
        { key: 'sort', label: 'Порядок', sortable: true },
        { key: 'id', label: '', sortable: false }
      ],
    };
  },
  computed: {
    ...mapState({
      items: state => state.docs.items,
      host: state => state.host,
    }),
  },
  methods: {
    ...mapActions({
      initItems: 'docs/initItems', // -> this.initItems()
      initEditingItem: 'docs/initEditingItem', // -> this.initEditingItem()
      alertMsg: 'alertMsg', // -> this.alertMsg()
    }),
    init() {
      const path = this.host + 'docs';
      axios.post(path, {}, { headers: { Authorization: `Bearer ${localStorage.token}` } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.isBusy = true;
            this.initItems({
              items: res.data.docs
            });
            this.isBusy = false;
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          if (error.response.status === 401){
            this.$store.dispatch('init', { email: localStorage.email, id: '', token: '' });
            this.$router.push('/login');
          }
        });
    },
    delete_item(item_id) {
      const path = this.host + 'delete_doc';
      //console.log(10)
      axios.post(path, {'id': item_id}, { headers: { Authorization: `Bearer ${localStorage.token}` } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.init();
            this.alertMsg({
              alert: res.data.message,
              type: 'success',
            });
          } else {
            this.alertMsg({
              alert: res.data.error,
              type: 'danger',
            });
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          // console.log(error);
          //console.log(error.response, error.response.status)
          if (error.response.status === 401){
            this.$router.push('/login');
          }
        });
    },
    edit_item(item_id) {
      this.initEditingItem({
        'index': item_id
      })
      this.$bvModal.show('modal-edit-doc');
    },
  },
  created() {
    this.init();
  },
};
</script>

<style>
  .head-group{
    margin-bottom: 15px;
  }
  td{
    min-width: 150px;
    line-break: break-all;
    word-break: break-word;
  }
  .link_doc, .link_doc:hover {
    color: #fff !important;
    text-decoration: underline;
  }
</style>
